"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isObjectLiteral = exports.compareObjects = void 0;

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var isObjectLiteral = function isObjectLiteral(obj) {
  return obj && _typeof(obj) === "object" && !Array.isArray(obj);
};

exports.isObjectLiteral = isObjectLiteral;

var compareObjects = function compareObjects(obj1, obj2) {
  if (obj1 === obj2) return true;
  if (!obj1 || !obj2) return false;
  if (Object.keys(obj1).length !== Object.keys(obj2).length) return false;

  for (var key in obj1) {
    if (!compareObjects(obj1[key], obj2[key])) return false;
  }

  return true;
};

exports.compareObjects = compareObjects;